import React from 'react';
import styles from './toggle-switch.module.scss';

export type ToggleSwitchProps = { label?: string; labelId: string; id: string } & Pick<
  React.InputHTMLAttributes<HTMLInputElement>,
  'checked' | 'name' | 'value' | 'className' | 'disabled' | 'required' | 'onChange'
>;

const baseClass = `toggle-switch`;

export const ToggleSwitch = React.forwardRef<HTMLInputElement, ToggleSwitchProps>(
  ({ id, label, disabled, name, value, checked, onChange, required, labelId }, ref) => (
    <div className={styles[baseClass]} data-testid="toggle-component">
      <input
        id={id}
        type="checkbox"
        disabled={disabled}
        className={styles[`${baseClass}__input`]}
        onChange={onChange}
        checked={checked}
        name={name}
        value={value}
        aria-labelledby={labelId}
        ref={ref}
        required={required}
      />
      <div className={styles[`${baseClass}__switch-wrapper`]}>
        <span className={styles[`${baseClass}__switch-visual`]} />
      </div>
      {label && (
        <label htmlFor={id} id={labelId} className={styles[`${baseClass}__label`]}>
          {label}
        </label>
      )}
    </div>
  )
);

ToggleSwitch.displayName = 'ToggleSwitch';
